import { Text } from '@noorden-insurtech/alba-design-system';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { useState } from 'react';
import type { CgPolicyPremiumCard } from './map-policy-details-to-capital-global-view.util';

type Props = {
  data: CgPolicyPremiumCard;
  defaultExpanded?: boolean;
};

function Field({ label, value }: { label: string; value: string }) {
  return (
    <div className='flex flex-col items-start gap-y-0 min-w-0'>
      <Text className='text-xs text-alba-white-500'>{label}</Text>
      <Text className='truncate text-sm font-bold text-alba-white-500'>{value}</Text>
    </div>
  );
}

/**
 * Card de prêmio da apólice Capital Global (layout dos anexos): topo com o
 * prêmio total, linha de pagamento (líquido/IOF/periodicidade/forma) e parte
 * colapsável com produto/nº apólice/dia de vencimento/status.
 */
export function CapitalGlobalPolicyPremiumCard({
  data,
  defaultExpanded = true,
}: Props) {
  const [collapsed, setCollapsed] = useState(!defaultExpanded);

  return (
    <div className='flex w-full'>
      <div className='relative flex w-full flex-col items-center self-stretch rounded-2xl bg-linear-to-br from-[#2C285F] to-[#18163D] px-6 py-6 text-center'>
        <button
          onClick={() => setCollapsed(!collapsed)}
          className='absolute top-0 right-0 cursor-pointer border-none bg-transparent px-6 py-4'
        >
          {collapsed ? (
            <ChevronDown className='size-6 text-alba-white-500' />
          ) : (
            <ChevronUp className='size-6 text-alba-white-500' />
          )}
        </button>

        <Text className='mb-2 text-sm text-alba-white-500'>Prêmio Total</Text>
        <Text className='text-3xl font-bold leading-[44px] text-alba-white-500'>
          {data.totalValue}
        </Text>

        <div className='mt-4 grid w-full grid-cols-2 gap-x-6 gap-y-4 sm:grid-cols-4 sm:gap-x-3'>
          <Field label='Prêmio Líquido' value={data.liquidValue} />
          <Field label='IOF' value={data.iofValue} />
          <Field label='Periodicidade de pagamento' value={data.periodicity} />
          <Field label='Forma de pagamento' value={data.paymentMethod} />
        </div>

        {!collapsed && (
          <div className='mt-4 grid w-full grid-cols-2 gap-x-6 gap-y-4 border-t border-[#9FA4A6] pt-4 sm:grid-cols-4 sm:gap-x-3'>
            <Field label='Produto' value={data.product} />
            <Field label='Número da Apólice' value={data.policyNumber} />
            <Field label='Dia de vencimento:' value={data.dueDay} />
            <Field label='Status' value={data.status} />
          </div>
        )}
      </div>
    </div>
  );
}
